
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { FileText, MessageSquare } from "lucide-react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { getPosts } from "@/services/postService";
import { Post } from "@/types/board";

const LatestPostsSection = () => {
  const [posts, setPosts] = useState<Post[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const allPosts = await getPosts();
        setPosts(allPosts.slice(0, 5)); // Get first 5 posts
      } catch (error) {
        console.error("Error fetching latest posts:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  // Handle post click based on category
  const handlePostClick = (post: Post, e: React.MouseEvent) => {
    if (post.category === 'Weee Link 공유') {
      e.preventDefault();
      window.location.href = post.content;
      return;
    }
    // 스크롤 맨 위로
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  };

  return (
    <Card className="shadow-sm">
      <CardHeader className="pb-2 pt-3">
        <CardTitle className="text-base font-medium flex items-center gap-1.5">
          <FileText size={16} className="text-primary" />
          최신글
        </CardTitle>
      </CardHeader>
      <CardContent className="px-4 py-2">
        {loading ? (
          <div className="text-center py-1.5 text-muted-foreground text-sm">불러오는 중...</div>
        ) : posts.length > 0 ? (
          <ul className="space-y-1.5">
            {posts.map((post) => (
              <li key={post.id} className="pb-1.5 last:pb-0">
                <Link 
                  to={`/board/post/${post.id}`} 
                  className="flex hover:text-primary transition-colors"
                  onClick={(e) => handlePostClick(post, e)}
                >
                  <span className="line-clamp-1 text-sm flex-1">{post.title}</span>
                  {(post.commentCount > 0 || post.comment_count > 0) && (
                    <span className="ml-1.5 text-xs text-muted-foreground flex items-center">
                      <MessageSquare className="h-3 w-3 mr-0.5" />
                      {post.commentCount || post.comment_count}
                    </span>
                  )}
                </Link>
              </li>
            ))}
          </ul>
        ) : (
          <div className="text-center py-1.5 text-muted-foreground text-sm">게시글이 없습니다</div>
        )}
      </CardContent>
    </Card>
  );
};

export default LatestPostsSection;
